<footer class="bg-teal-900 text-gray-100 py-12 px-6 overflow-x-hidden">
  <div class="mx-auto max-w-7xl grid grid-cols-1 md:grid-cols-4 gap-8">
    <!-- Logo & Description (takes 2 cols) -->
    <div class="md:col-span-2 flex flex-col">
      <img
        src="assets/TrailFusion/logo.png"
        alt="TrailFusion Logo"
        class="w-40 bg-white p-2 rounded-lg mb-4 transform hover:scale-105 transition-transform duration-300"
      />
      <p class="text-lg text-teal-100 leading-relaxed mb-4">
        All in all, our programs at TrailFusion are designed to inspire,
        educate, and empower children to reach their full potential. By
        fostering curiosity, teamwork, and resilience, we help them develop
        essential life skills that go beyond the classroom.
      </p>
      <p class="text-lg text-teal-100 leading-relaxed mb-4">
        Empowering people with awesome programs and workshops.
      </p>
    </div>

    <!-- Quick Links (1 col) -->
    <div>
      <h3
        class="text-2xl font-extrabold text-white mb-4 pb-2 border-b border-teal-700"
      >
        Quick Links
      </h3>
      <div class="flex flex-col space-y-4">
        <a
          href="/about-us"
          class="text-lg text-teal-100 hover:text-white transition-colors duration-300"
        >
          About Us
        </a>
        <a
          href="/explore-programs"
          class="text-lg text-teal-100 hover:text-white transition-colors duration-300"
        >
          Programs
        </a>
        <a
          href="/our-clients"
          class="text-lg text-teal-100 hover:text-white transition-colors duration-300"
        >
          Clients
        </a>
        <a
          href="/contactus"
          class="text-lg text-teal-100 hover:text-white transition-colors duration-300"
        >
          Contact
        </a>
        <a
          href="/privacy-policy"
          class="text-lg text-teal-100 hover:text-white transition-colors duration-300"
        >
          Privacy Policy
        </a>
        <a
          href="/faq"
          class="text-lg text-teal-100 hover:text-white transition-colors duration-300"
        >
          FAQ's
        </a>
      </div>
    </div>

    <!-- Follow Us (1 col) -->
    <div>
      <h3
        class="text-2xl font-extrabold text-white mb-4 pb-2 border-b border-teal-700"
      >
        Follow Us
      </h3>
      <p class="text-lg text-teal-100 mb-4">
        Stay connected with our community
      </p>
      <div class="flex space-x-4">
        <a
          href="https://www.facebook.com/profile.php?id=61580029765412"
          target="_blank"
          aria-label="Facebook"
          class="bg-teal-800 p-3 rounded-full hover:bg-teal-700 transition-all duration-300 transform hover:scale-105 flex items-center justify-center w-10 h-10"
        >
          <i class="fab fa-facebook-f text-white text-lg"></i>
        </a>

        <a
          href="https://x.com/trailfusion"
          target="_blank"
          aria-label="X (Twitter)"
          class="bg-teal-800 p-3 rounded-full hover:bg-teal-700 transition-all duration-300 transform hover:scale-105 flex items-center justify-center w-10 h-10"
        >
          <i class="fa-brands fa-x-twitter text-lg"></i>
        </a>
        <a
          href="https://www.linkedin.com/in/trailfusion/"
          target="_blank"
          aria-label="LinkedIn"
          class="bg-teal-800 p-3 rounded-full hover:bg-teal-700 transition-all duration-300 transform hover:scale-105 flex items-center justify-center w-10 h-10"
        >
          <i class="fab fa-linkedin-in text-lg"></i>
        </a>
        <a
          href="https://www.instagram.com/trailfusion_/"
          target="_blank"
          aria-label="Instagram"
          class="bg-teal-800 p-3 rounded-full hover:bg-teal-700 transition-all duration-300 transform hover:scale-105 flex items-center justify-center w-10 h-10"
        >
          <i class="fab fa-instagram text-lg"></i>
        </a>
      </div>
    </div>
  </div>

  <!-- Bottom Footer -->
  <div class="border-t border-teal-800 mt-10 pt-6">
    <div
      class="mx-auto max-w-7xl flex flex-col md:flex-row justify-center items-center"
    >
      <div class="text-lg text-teal-200 text-center">
        © {{ currentYear }} TrailFusion. All rights reserved.
      </div>
    </div>
  </div>
</footer>
<link
  rel="stylesheet"
  href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.5.1/css/all.min.css"
/>
